import { Sprout } from 'lucide-react'

export default function EmptyState({ icon: Icon = Sprout, title, description, action, compact = false }) {
  return (
    <div className={`empty-state ${compact ? 'empty-state-compact' : ''}`}>
      <span className="empty-icon"><Icon aria-hidden="true" /></span>
      <div><h3>{title}</h3>{description && <p>{description}</p>}</div>
      {action}
    </div>
  )
}
